// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/solar-panels.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tło całej strony logowania */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}

.login-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* lub .webp jeśli skompresujesz */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.login-container {
  border: 1px solid #ccc;
  border-radius: 8px; /* Added rounded corners */
  padding: 40px; /* Increased padding for more space */
  width: 100%; /* Full width to max width */
  max-width: 320px; /* Max width for the form */
  margin: 50px auto; /* Increased top margin and center horizontally */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Added subtle shadow for depth */
  background-color: #fff; /* Added a background color */
  text-align: left; /* Align text to the left */
}

.login-container h2 {
  margin-bottom: 20px; /* Added bottom margin for spacing */
  color: #333; /* Dark grey color for better contrast */
  font-size: 24px; /* Increased font size */
}

.login-container label {
  display: block; /* Make labels block to take full width */
  margin-bottom: 5px; /* Add some space below the label */
  color: #666; /* Lighter text color for the labels */
  font-size: 14px; /* Smaller font size for labels */
}

.login-container input {
  width: 100%; /* Full width inputs */
  padding: 10px; /* Padding inside the inputs */
  margin-bottom: 20px; /* Space after each input */
  border: 1px solid #ddd; /* Lighter border color */
  border-radius: 4px; /* Slightly rounded corners on inputs */
  box-sizing: border-box; /* Border box sizing */
}

.login-container button {
  width: 100%; /* Full width button */
  padding: 10px; /* Padding inside the button */
  border: none;
  background-color: #0056b3;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
  transition: background-color 0.3s ease;
}

.login-container button:hover {
  background-color: #003d82;
}

.login-container .error {
  color: #d9534f;
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yDAAoD,EAAE,kCAAkC;EACxF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB,EAAE,0BAA0B;EAC9C,aAAa,EAAE,qCAAqC;EACpD,WAAW,EAAE,4BAA4B;EACzC,gBAAgB,EAAE,2BAA2B;EAC7C,iBAAiB,EAAE,iDAAiD;EACpE,wCAAwC,EAAE,kCAAkC;EAC5E,sBAAsB,EAAE,6BAA6B;EACrD,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,mBAAmB,EAAE,oCAAoC;EACzD,WAAW,EAAE,wCAAwC;EACrD,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,cAAc,EAAE,yCAAyC;EACzD,kBAAkB,EAAE,mCAAmC;EACvD,WAAW,EAAE,sCAAsC;EACnD,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,aAAa,EAAE,8BAA8B;EAC7C,mBAAmB,EAAE,2BAA2B;EAChD,sBAAsB,EAAE,yBAAyB;EACjD,kBAAkB,EAAE,uCAAuC;EAC3D,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,aAAa,EAAE,8BAA8B;EAC7C,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Tło całej strony logowania */\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.login-background {\n  background-image: url(\"../images/solar-panels.webp\"); /* lub .webp jeśli skompresujesz */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.login-container {\n  border: 1px solid #ccc;\n  border-radius: 8px; /* Added rounded corners */\n  padding: 40px; /* Increased padding for more space */\n  width: 100%; /* Full width to max width */\n  max-width: 320px; /* Max width for the form */\n  margin: 50px auto; /* Increased top margin and center horizontally */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Added subtle shadow for depth */\n  background-color: #fff; /* Added a background color */\n  text-align: left; /* Align text to the left */\n}\n\n.login-container h2 {\n  margin-bottom: 20px; /* Added bottom margin for spacing */\n  color: #333; /* Dark grey color for better contrast */\n  font-size: 24px; /* Increased font size */\n}\n\n.login-container label {\n  display: block; /* Make labels block to take full width */\n  margin-bottom: 5px; /* Add some space below the label */\n  color: #666; /* Lighter text color for the labels */\n  font-size: 14px; /* Smaller font size for labels */\n}\n\n.login-container input {\n  width: 100%; /* Full width inputs */\n  padding: 10px; /* Padding inside the inputs */\n  margin-bottom: 20px; /* Space after each input */\n  border: 1px solid #ddd; /* Lighter border color */\n  border-radius: 4px; /* Slightly rounded corners on inputs */\n  box-sizing: border-box; /* Border box sizing */\n}\n\n.login-container button {\n  width: 100%; /* Full width button */\n  padding: 10px; /* Padding inside the button */\n  border: none;\n  background-color: #0056b3;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 10px;\n  transition: background-color 0.3s ease;\n}\n\n.login-container button:hover {\n  background-color: #003d82;\n}\n\n.login-container .error {\n  color: #d9534f;\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
